import { gql } from 'graphql.macro';
import { apiClientFieldsFragment } from 'apollo/fragments/api-client';

export const getApiClientsForOrganizationTemplate = gql`
    query apiClientsForOrganization($organizationId: MongoDbObjectId!) {
        apiClientsForOrganization(organizationId: $organizationId) {
            ...apiClientFields
        }
    }
    ${apiClientFieldsFragment}
`;
